import React from 'react';
import styles from './ResourceTagList.module.scss';
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';

interface Resource {
  resource_id: string | number;
  resource_name: string;
}

interface Props {
  resources: Resource[];
  setTopActionsDetails: React.Dispatch<React.SetStateAction<any>>;
  isDisabled?: boolean;
}

const ResourceTagList: React.FC<Props> = ({ resources, setTopActionsDetails, isDisabled }) => {
  const handleRemove = (id: string | number) => {
    setTopActionsDetails((prev: any) => {
      const updatedResources = (prev.resources || []).filter(
        (res: any) => res.resource_id !== id
      );

      const updatedResourceIds = (prev.resource_ids || []).filter(
        (resId: any) => resId !== id
      );

      const executedResourceName = updatedResources
        .map((res: any) => res.resource_name)
        .join(', ');

      return {
        ...prev,
        resources: updatedResources,
        resource_ids: updatedResourceIds,
        executed_resource_name: executedResourceName,
      };
    });
  };

  return (
    <div className={styles.tagContainer}>
      {resources.map((res) => (
        <div key={res.resource_id} className={styles.tag}>
          <span>{res.resource_name}</span>
          {
            isDisabled
              ?
              <> </>
              :
              <button
                type="button"
                className={styles.closeButton}
                onClick={() => handleRemove(res.resource_id)}
              >
                <CloseIcon />
              </button>
          }
        </div>
      ))}
    </div>
  );
};

export default ResourceTagList;
